/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessReportRowDTOFromJSON, BusinessReportRowDTOToJSON, } from './BusinessReportRowDTO';
/**
 * Check if a given object implements the PaginatedResponseBusinessReportRowDTO interface.
 */
export function instanceOfPaginatedResponseBusinessReportRowDTO(value) {
    return true;
}
export function PaginatedResponseBusinessReportRowDTOFromJSON(json) {
    return PaginatedResponseBusinessReportRowDTOFromJSONTyped(json, false);
}
export function PaginatedResponseBusinessReportRowDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(BusinessReportRowDTOFromJSON)),
    };
}
export function PaginatedResponseBusinessReportRowDTOToJSON(json) {
    return PaginatedResponseBusinessReportRowDTOToJSONTyped(json, false);
}
export function PaginatedResponseBusinessReportRowDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(BusinessReportRowDTOToJSON)),
    };
}
